import { faClose } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Formik } from 'formik'
import React, { useState } from 'react'
import AppSubmit from './formik/AppSubmit'
import AppInput from './formik/AppInput'
import AppTextArea from './formik/AppTextArea'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import instance from '../api/client'
import authService from '../authentication'
import IconButton from './IconButton'
import NormalInput from './NormalInput'


const validationSchema = Yup.object().shape({
  description: Yup.string().required().label("Description"),
});

export default function InputModal({ hidden, setHidden, acceptanceFunction, value, setValue, placeholder, label }) {


  return (
    <div className={`${hidden ? 'hidden' : ''} absolute z-[51] flex w-full h-full items-center justify-center bg-modal`}>
      <div className='w-[450px] bg-white rounded-lg p-5'>
        <div className='font-semibold capitalize flex justify-end'>
          {/* <div>{title}</div> */}
          <div onClick={()=>setHidden(true)} className='px-2 border-2 border-gray-300 cursor-pointer rounded hover:bg-gray-700 hover:text-white'><FontAwesomeIcon icon={faClose} size={30} /></div>
        </div>
        {/* <div className='bg-gray-300 h-[1px] w-full mt-5 mb-10' /> */}
        {/* <div>
          {message}
        </div> */}
        <NormalInput value={value} label={label} onChange={(e)=>setValue(e.target.value)} placeholder={placeholder}/>
        <div className='flex justify-end gap-5 mt-5'>
          {/* <IconButton boxClassName={'px-5 hover:border-2 hover:border-black'} onClick={() => { setHidden(true) }} title={'No'} /> */}
          <IconButton boxClassName={'bg-teal-600 text-white px-5 hover:bg-teal-600 hover:border-2 hover:border-black'} onClick={()=>{acceptanceFunction(); setHidden(true); setValue('')}} title={'Submit'} />
        </div>
      </div>
    </div>
  )
}
